import { useContext, useEffect, useState } from 'react';
import AppContext from '../../../AppContext';
import Environment from '../../../Environment';
import AdditionalCompanySectionData from './AdditionalCompanySectionData';
import AdditionalCompanyRowData from './AdditionalCompanyRowData';
import styles from './AdditionalCompanyInformation.module.css';
import LoadingText from '../../Loading/LoadingText/LoadingText';
import ISiteLink from '../../links/ISiteLink';
import { cachedFetch } from '../../../utils/cachedFetch';

export default function AdditionalCompanyInformation() {
  const { cocode, year, periodType, riskRepository, statementType } = useContext(AppContext);
  const [error, setError] = useState<Error | null>(null);
  const [additionalCompanyInfoData, setAdditionalCompanyInfoData] =
    useState<AdditionalCompanySectionData | null>(null);

  useEffect(() => {
    let url = `${Environment.API_URL()}/additional_company_information?cocode=${cocode}&year=${year}`;
    if (periodType) url += `&periodType=${periodType}`;
    cachedFetch(url, {
      headers: {
        Authorization: `${sessionStorage.getItem('bearerToken')}`
      }
    }).then(
      (res) => {
        if (!res.ok) {
          let error = new Error(res.statusText);
          setError(error);
        } else {
          res.json().then(
            (data) => setAdditionalCompanyInfoData(data),
            (error) => console.error(error)
          );
        }
      },
      (error) => setError(error)
    );
  }, [cocode, year, periodType]);

  const additionalCompanyInfoTitle = 'Additional Company Information';

  function getAnswerTextValue(row: AdditionalCompanyRowData) {
    if (row.rowKey === 'company-overview-1.6' && row.answer.textValue === 'YES') {
      return (
        <ISiteLink
          relativeUrl={`/profile/PROMergeHist?COCODE=${cocode}&DATA_YEAR=${year}&SECTION_ID=100&STMT_TYPE=${statementType.statementTypeId}`}
          label={row.answer.textValue}
        />
      );
    } else if (row.rowKey === 'company-overview-1.7' && row.answer.textValue?.toUpperCase() === 'OTHER') {
      return 'Other than HMO, HMDI, LHSO or ODS';
    } else {
      return row.answer.textValue;
    }
  }

  if (riskRepository === 'AC') {
    return (
      <>
        <h2 className="section_title">{additionalCompanyInfoTitle}</h2>
        {error && <p>Error retrieving data</p>}
        {!error && !additionalCompanyInfoData && <LoadingText label={additionalCompanyInfoTitle} />}

        <div data-testid="company_info_container" className={styles.company_info_container}>
          {additionalCompanyInfoData?.companyQuestionRows && [
            additionalCompanyInfoData.companyQuestionRows.map((row: AdditionalCompanyRowData) => {
              if (row.rowKey === 'company-overview-1.7' && statementType?.statementTypeId !== 9) {
                return null;
              }
              return (
                <div
                  key={row.rowKey}
                  id={'rowKey-' + row.rowKey}
                  data-testid="company_info_unit"
                  className={styles.company_info_unit}>
                  <p className={styles.company_info_question}>{row.label}</p>
                  <p>{getAnswerTextValue(row)}</p>
                </div>
              );
            })
          ]}
        </div>
      </>
    );
  } else {
    return null;
  }
}
